import SelectSettings from './select_settings';

export default SelectSettings;
